const flightsResultService = ({ api, promiseBuilder, baseUrl }) => ({
  // GETS //////////////////////////////////////////////////
  getConfig: (apiEndpoint) => {
    let response = null
    if (process.env.VUE_APP_FAKE_CONFIG_V2) {
      response = promiseBuilder(process.env.VUE_APP_FAKE_CONFIG_V2)
    } else {
      response = api.get(baseUrl + `flightresults/api/v2/${apiEndpoint}/`)
    }
    return response
  },
  // POSTS //////////////////////////////////////////////////
  flightAction: (apiVersion, params) => {
    const response = api.post(baseUrl + 'flightresults/api/' + apiVersion + '/action/', params)
    return response
  },
  setConfig: (apiEndpoint, params) => {
    let response = null
    if (process.env.VUE_APP_FAKE_CONFIG_V2) {
      response = promiseBuilder(process.env.VUE_APP_FAKE_CONFIG_V2)
    } else {
      response = api.post(baseUrl + `flightresults/api/v2/${apiEndpoint}/`, params)
    }
    return response
  }
})

export { flightsResultService }
